import type { ThemeConfig } from 'antd';
import { theme } from 'antd';
import type { ResolvedTheme } from './theme.interface';

export const mapToAntdTheme = (resolved: ResolvedTheme): ThemeConfig => {
    const isDark = resolved.mode === 'dark';

    return {
        algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: {
            colorPrimary: resolved.brand.primary[0],
            colorLink: resolved.brand.primary[0],
            colorSuccess: resolved.brand.green[0],
            colorError: resolved.brand.red[0],
            colorWarning: resolved.brand.yellow[0],
            colorInfo: resolved.brand.blue[0],
            borderRadius: resolved.brand.radius.md,
            borderRadiusLG: resolved.brand.radius.md,
            borderRadiusSM: resolved.brand.radius.sm,
            fontFamily: resolved.brand.fontFamily,
            controlHeightLG: 36,
            fontSizeLG: 14,
        },
        components: {
            ...(resolved.components as ThemeConfig['components']),
            Button: {
                fontWeight: 600,
            },
            Select: {
                optionPadding: '4px 12px',
            },
            Notification: {
                width: 300,
                fontSize: 12,
                fontSizeLG: 16,
                padding: 12,
                paddingMD: 12,
                paddingContentHorizontalLG: 12,
            },
        },
    };
};
